import styled from '@mui/material/styles/styled';
import List from '@mui/material/List';
import Box from '@mui/material/Box';

export const Root = styled(Box)(() => ({
  flexShrink: 0,
  width: 300,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  background: '#fff'
}));
export const StyledList = styled(List)(({ theme }) => ({
  flexGrow: 1,
  overflowY: 'auto',
  ...theme.scrollbars.paper,
}));